import { createStyles, makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { FC, useState, useEffect } from 'react';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import { useApi } from 'src/@context/Api';
import * as classNames from 'classnames';
import stylesheet, { secondaryColor, tertiaryColor, mainColor, bodyFontSize } from 'src/constants/stylesheet';
import GoogleMaps from './GoogleMap';
import { GOOGLE_MAP_KEY } from 'src/constants/GoogleMap';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
    },
    rootInner: {
      position: 'relative',
      maxWidth: spacing.websiteMaxWidth,
      margin: '0 auto',
      [mediaQueries.Mobile]: {
        paddingTop: spacing.Gutter.Mobile,
        paddingLeft: spacing.Gutter.Mobile,
        paddingRight: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        paddingLeft: spacing.Gutter.Tablet / 2,
        paddingRight: spacing.Gutter.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: spacing.Gutter.Laptop / 2,
        paddingRight: spacing.Gutter.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: spacing.Gutter.Desktop / 2,
        paddingRight: spacing.Gutter.Desktop / 2,
      },
    },
    contactInformations: {
      display: 'flex',
      alignItems: 'flex-end',
      opacity: 1,
      transition: 'opacity .4s ease',
      [mediaQueries.Mobile]: {
        flexWrap: 'wrap',
        paddingTop: spacing.Gutter.Mobile,
        paddingBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        paddingTop: spacing.Gutter.Tablet,
        paddingBottom: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        paddingTop: spacing.Gutter.Laptop,
        paddingBottom: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        paddingTop: spacing.Gutter.Desktop,
        paddingBottom: spacing.Gutter.Desktop,
      },
    },
    column: {
      [mediaQueries.Mobile]: {
        flex: `100%`,
        paddingBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        flex: `0 0 ${1 / 3 * 100}%`,
        paddingLeft: spacing.Gutter.Mobile / 2,
        paddingRight: spacing.Gutter.Mobile / 2,
      },
      [mediaQueries.Laptop]: {
        flex: `0 0 ${1 / 3 * 100}%`,
        paddingLeft: spacing.Gutter.Laptop / 2,
        paddingRight: spacing.Gutter.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        flex: `0 0 ${1 / 3 * 100}%`,
        paddingLeft: spacing.Gutter.Desktop / 2,
        paddingRight: spacing.Gutter.Desktop / 2,
      }
    },
    ContactTitle: {
      color: secondaryColor,
      fontSize: '3rem',
      lineHeight: 1,
      [mediaQueries.Mobile]: {
        display: 'none'
      },
    },
    form: {
      [mediaQueries.Mobile]: {},
      [mediaQueries.Tablet]: {
        // paddingTop: spacing.Gutter.Tablet,
        paddingbottom: spacing.Gutter.Tablet,
        marginLeft: -spacing.Gutter.Mobile / 2,
        marginRight: -spacing.Gutter.Mobile / 2,
      },
      [mediaQueries.Laptop]: {
        // paddingTop: spacing.Gutter.Laptop,
        paddingbottom: spacing.Gutter.Laptop,
        marginLeft: -spacing.Gutter.Laptop / 2,
        marginRight: -spacing.Gutter.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        // paddingTop: spacing.Gutter.Desktop,
        paddingBottom: spacing.Gutter.Desktop,
        marginLeft: -spacing.Gutter.Desktop / 2,
        marginRight: -spacing.Gutter.Desktop / 2,
      },
    },
    inputOuter: {
      display: 'inline-block',
      width: '100%',
      [mediaQueries.Mobile]: {
        paddingBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        paddingLeft: spacing.Gutter.Tablet / 2,
        paddingRight: spacing.Gutter.Tablet / 2,
        paddingBottom: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: spacing.Gutter.Laptop / 2,
        paddingRight: spacing.Gutter.Laptop / 2,
        paddingBottom: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: spacing.Gutter.Desktop / 2,
        paddingRight: spacing.Gutter.Desktop / 2,
        paddingBottom: spacing.Gutter.Desktop,
      },
    },
    inputOuterHalf: {
      [mediaQueries.Mobile]: {
        width: '100%',
      },
      [mediaQueries.AfterMobile]: {
        width: '50%',
      },
    },
    inputOuterTextArea: {
      [mediaQueries.Mobile]: {
        paddingBottom: spacing.Gutter.Mobile / 2,
      },
      [mediaQueries.Tablet]: {
        paddingBottom: spacing.Gutter.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        paddingBottom: spacing.Gutter.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        paddingBottom: spacing.Gutter.Desktop / 2,
      },
    },
    input: {
      display: 'block',
      width: '100%',
      ...stylesheet.MediumText,
      fontSize: '1rem',
      border: `1px solid transparent`,
      borderBottom: `1px solid ${mainColor}`,
      padding: '3px 3px 3px 12px',
      height: 42,

      '&:hover': {
        border: `1px solid ${tertiaryColor}`,
      },
      '&:invalid': {
        border: `1px solid rgba(255, 64, 64, 1)`,
        backgroundColor: 'rgba(255, 64, 64, 0.1)',
      },
      '&$error': {
        border: `1px solid rgba(255, 64, 64, 1)`,
        backgroundColor: 'rgba(255, 64, 64, 0.1)',
      }
    },
    error: {},
    textarea: {
      display: 'block',
      width: '100%',
      minHeight: 130,
      ...stylesheet.MediumText,
      fontSize: '1rem',
      border: `1px solid transparent`,
      borderBottom: `1px solid ${mainColor}`,
      padding: '12px 3px 3px 12px',

      '&$error': {
        border: `1px solid rgba(255, 64, 64, 1)`,
        backgroundColor: 'rgba(255, 64, 64, 0.1)',
      },
      '&:hover': {
        border: `1px solid ${tertiaryColor}`,
      },
      '&:invalid': {
        border: `1px solid rgba(255, 64, 64, 1)`,
        backgroundColor: 'rgba(255, 64, 64, 0.1)',
      }
    },
    sendBtn: {
      ...stylesheet.MediumText,
      display: 'block',
      margin: '0 auto',
      border: 0,
      fontSize: '1.2rem',
      cursor: 'pointer',
      color: secondaryColor,
      '&:hover': {
        color: tertiaryColor
      },
      [mediaQueries.Mobile]: {
        fontSize: `${14 / bodyFontSize.Mobile}rem`,
      },
      [mediaQueries.Tablet]: {
        fontSize: `${14 / bodyFontSize.Tablet}rem`,
      },
      [mediaQueries.Laptop]: {
        fontSize: `${14 / bodyFontSize.Laptop}rem`,
      },
      [mediaQueries.Desktop]: {
        fontSize: `${14 / bodyFontSize.Desktop}rem`,
      },
    },
    googleMap: {
      position: 'relative',
      marginTop: 40,
      [mediaQueries.Mobile]: {
        height: 250,
      },
      [mediaQueries.AfterMobile]: {
        height: 700,
      },
    },
    emailConfirmtion: {
      textAlign: 'center'
    },
    emailSuccess: {
      color: 'green',
    },
    emailError: {
      color: 'rgb(255, 64, 64)'
    },
  }));
export type ContactProps = ContactDto;

type Props = ContactProps;

const Contact: FC<Props> = ({ Coordinates, Address }) => {
  const cls = useStyles();
  const { app, sendEmail } = useApi();
  const [name, setName] = useState<string>();
  const [email, setEmail] = useState<string>();
  const [subject, setSubject] = useState<string>();
  const [message, setMessage] = useState<string>();
  const [nameFilled, setNameFilled] = useState(false);
  const [emailValid, setEmailValid] = useState(false);
  const [subjectFilled, setSubjectFilled] = useState(false);
  const [messageFilled, setMessageFilled] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [emailSent, setEmailSent] = useState<boolean>();

  const [count, setCount] = useState(0);

  const Config = app && app.Config;

  useEffect(() => {
    validateForm();
  },
    [nameFilled, emailValid, messageFilled, subjectFilled]);

  const isValid = (e: React.FocusEvent<HTMLInputElement> | React.FocusEvent<HTMLTextAreaElement>) => {
    const input = e.target.name;
    const value = e.target.value;
    setCount(prevCount => prevCount + 1);
    switch (input) {
      case 'email':
        const valid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        setEmailValid(valid ? valid.length > 0 : false);
        break;
      case "name":
        setNameFilled(value.length > 0);
        return;
      case "subject":
        setSubjectFilled(value.length > 0);
        return;
      case "message":
        setMessageFilled(value.length > 0);
        return;
      default:
        break;
    }
  };

  const validateForm = () => {
    setFormValid(nameFilled && emailValid && subjectFilled && messageFilled);
    return;
  }

  const submitForm: React.FormHTMLAttributes<HTMLFormElement>['onSubmit'] = async (e) => {
    e.preventDefault();
    if (count === 0) {
      setCount(1);
      return;
    }
    if (formValid) {
      sendEmail(name!, email!, subject!, message!)
        .then(response => setEmailSent(response));
    }
  };

  return (
    <section className={cls.root}>
      <div className={cls.rootInner}>
        <div className={cls.contactInformations}>
          <h3 className={classNames(cls.column, cls.ContactTitle)}>Nous contacter</h3>
          {Config &&
            <>
              <div className={cls.column} dangerouslySetInnerHTML={{ __html: Config.Address }} />
              <div className={cls.column} dangerouslySetInnerHTML={{ __html: Config.Contacts }} />
            </>
          }
        </div>
        <form className={cls.form} onSubmit={submitForm}>
          <label className={classNames(cls.inputOuter, cls.inputOuterHalf)}>
            <input
              type='text'
              name='name'
              value={name}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={e => setName(e.target.value)}
              className={classNames(cls.input, !nameFilled && count > 0 && cls.error)}
              placeholder='Nom'
              // tslint:disable-next-line:jsx-no-lambda
              onBlur={e => isValid(e)}
            />
          </label>
          <label className={classNames(cls.inputOuter, cls.inputOuterHalf)}>
            <input
              name='email'
              type='email'
              value={email}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={e => setEmail(e.target.value)}
              placeholder='Email'
              className={classNames(cls.input, !emailValid && count > 0 && cls.error)}
              // tslint:disable-next-line:jsx-no-lambda
              onBlur={e => isValid(e)}
            />
          </label>
          <label className={cls.inputOuter}>
            <input
              name='subject'
              type='text'
              value={subject}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={e => setSubject(e.target.value)}
              className={classNames(cls.input, !subjectFilled && count > 0 && cls.error)}
              placeholder='Objet'
              // tslint:disable-next-line:jsx-no-lambda
              onBlur={e => isValid(e)}
            />
          </label>
          <label className={classNames(cls.inputOuter, cls.inputOuterTextArea)}>
            <textarea
              name='message'
              value={message}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={e => setMessage(e.target.value)}
              className={classNames(cls.textarea, !messageFilled && count > 0 && cls.error)}
              placeholder='Message'
              // tslint:disable-next-line:jsx-no-lambda
              onBlur={e => isValid(e)}
            />
          </label>
          <button className={cls.sendBtn}>Envoyer</button>
          {emailSent !== undefined &&
            <div className={classNames(cls.emailConfirmtion, emailSent ? cls.emailSuccess : cls.emailError)}>
              {emailSent ? 'Bravo votre mail à été envoyé avec succès' : 'Hoops il y a eu un problème!'}
            </div>
          }
        </form>
      </div>
      <section className={cls.googleMap}>
        <GoogleMaps
          lat={Coordinates.lat}
          lng={Coordinates.lng}
          googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GOOGLE_MAP_KEY}`}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `100%` }} />}
          mapElement={<div style={{ height: `100%` }} />}
        />
      </section>
    </section>
  );
};

export default Contact;


// WEBPACK FOOTER //
// ./src/Components/Contact.tsx